// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"ce640bd9","498":"770c2fc1","513":"016e7caf","703":"beed94c0"}[chunkId] + ".chunk.js";
};